<lfx-dropdown-filter-panel [activeFilterCount]="activeFilterCount()" (clearAll)="clearFilters()">
  <!-- Date From -->
  <div class="filter-group">
    <label class="filter-label">Date From</label>
    <p-datepicker
      appendTo="body"
      placeholder="From"
      dateFormat="mm/dd/yy"
      [ngModel]="dateFrom()"
      (ngModelChange)="dateFrom.set($event)"
      [showIcon]="true"
      styleClass="w-full" />
  </div>

  <!-- Date To -->
  <div class="filter-group">
    <label class="filter-label">Date To</label>
    <p-datepicker
      appendTo="body"
      placeholder="To"
      dateFormat="mm/dd/yy"
      [ngModel]="dateTo()"
      (ngModelChange)="dateTo.set($event)"
      [showIcon]="true"
      styleClass="w-full" />
  </div>

  <!-- Time Range -->
  <div class="filter-group">
    <label class="filter-label">Time Range</label>
    <p-select appendTo="body" [options]="periodOptions()" [ngModel]="period()" (ngModelChange)="period.set($event)" styleClass="w-full" />
  </div>

  <!-- Type -->
  @if (typeOptions().length > 0) {
    <div class="filter-group">
      <label class="filter-label">Type</label>
      <p-multiselect
        appendTo="body"
        [ngModel]="selectedTypes()"
        (ngModelChange)="selectedTypes.set($event)"
        [options]="typeOptions()"
        placeholder="Select types"
        styleClass="w-full"
        [panelStyle]="{ minWidth: '200px' }">
        <ng-template let-option pTemplate="item">
          <div class="text-sm">{{ option }}</div>
        </ng-template>
      </p-multiselect>
    </div>
  }

  <!-- Action -->
  @if (actionOptions().length > 0) {
    <div class="filter-group">
      <label class="filter-label">Action</label>
      <p-multiselect
        appendTo="body"
        [ngModel]="selectedActions()"
        (ngModelChange)="selectedActions.set($event)"
        [options]="actionOptions()"
        placeholder="Select actions"
        styleClass="w-full"
        [panelStyle]="{ minWidth: '200px' }">
        <ng-template let-option pTemplate="item">
          <div class="text-sm">{{ option }}</div>
        </ng-template>
      </p-multiselect>
    </div>
  }

  <!-- Committee -->
  @if (showCommitteeFilter() && committeeOptions().length > 0) {
    <div class="filter-group">
      <label class="filter-label">Committee</label>
      <p-multiselect
        appendTo="body"
        [ngModel]="selectedCommittees()"
        (ngModelChange)="selectedCommittees.set($event)"
        [options]="committeeOptions()"
        placeholder="Select committees"
        styleClass="w-full"
        [panelStyle]="{ minWidth: '250px' }">
        <ng-template let-option pTemplate="item">
          <div class="text-sm truncate">{{ option }}</div>
        </ng-template>
      </p-multiselect>
    </div>
  }

  <!-- Member -->
  @if (memberOptions().length > 0) {
    <div class="filter-group">
      <label class="filter-label">Member</label>
      <p-multiselect
        appendTo="body"
        [ngModel]="selectedMembers()"
        (ngModelChange)="selectedMembers.set($event)"
        [options]="memberOptions()"
        placeholder="Select members"
        styleClass="w-full"
        [panelStyle]="{ minWidth: '200px' }">
        <ng-template let-option pTemplate="item">
          <div class="text-sm truncate">{{ option }}</div>
        </ng-template>
      </p-multiselect>
    </div>
  }

  <!-- User -->
  @if (userOptions().length > 0) {
    <div class="filter-group">
      <label class="filter-label">User</label>
      <p-multiselect
        appendTo="body"
        [ngModel]="selectedUsers()"
        (ngModelChange)="selectedUsers.set($event)"
        [options]="userOptions()"
        placeholder="Select users"
        optionLabel="displayName"
        styleClass="w-full"
        [panelStyle]="{ minWidth: '250px' }">
        <ng-template let-option pTemplate="item">
          <div class="flex gap-2 items-center">
            @if (option.Avatar && option.Avatar !== '') {
              <p-avatar [image]="option.Avatar" (onImageError)="onImageError($event)" shape="circle" styleClass="avatar-image-fit !w-8 !h-8" />
            } @else {
              <p-avatar [label]="option.displayName || 'U' | initial" shape="circle" styleClass="!w-8 !h-8" />
            }
            <div class="text-sm truncate">{{ option.displayName || 'Unknown User' }}</div>
          </div>
        </ng-template>
      </p-multiselect>
    </div>
  }

  <!-- Field -->
  @if (fieldOptions().length > 0) {
    <div class="filter-group">
      <label class="filter-label">Field</label>
      <p-multiselect
        appendTo="body"
        [ngModel]="selectedFields()"
        (ngModelChange)="selectedFields.set($event)"
        [options]="fieldOptions()"
        placeholder="Select fields"
        styleClass="w-full"
        [panelStyle]="{ minWidth: '200px' }">
        <ng-template let-option pTemplate="item">
          <div class="text-sm truncate">{{ option }}</div>
        </ng-template>
      </p-multiselect>
    </div>
  }
</lfx-dropdown-filter-panel>
